import { FunctionComponent } from "react";
import styled from "styled-components";
import { ColorValues } from "../../Colors";

export enum ChevronOrientation {
  UP = "up",
  DOWN = "down",
  RIGHT = "right",
  LEFT = "left",
}

interface ChevronProps {
  orientation?: ChevronOrientation;
  color?: string;
  className?: string;
}

const StyledContainer = styled.div<{ orientation: ChevronOrientation }>`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease-in-out;
  transform: ${({ orientation }) =>
    orientation === ChevronOrientation.UP
      ? "rotate(180deg)"
      : orientation === ChevronOrientation.LEFT
      ? "rotate(90deg)"
      : orientation === ChevronOrientation.RIGHT
      ? "rotate(-90deg)"
      : "rotate(0deg)"};
  transform-origin: center;
`;

const Chevron: FunctionComponent<ChevronProps> = ({
  orientation = ChevronOrientation.DOWN,
  color = ColorValues.mint,
  className = "",
}: ChevronProps) => {
  return (
    <StyledContainer orientation={orientation} className={className}>
      <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6654_25960)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.746 0.729734C17.1799 1.16365 17.1799 1.86717 16.746 2.30108L9.67489 9.37215C9.24097 9.80607 8.53745 9.80607 8.10354 9.37215L1.03247 2.30108C0.598552 1.86717 0.598552 1.16365 1.03247 0.729734C1.46638 0.295818 2.1699 0.295818 2.60382 0.729734L8.88921 7.01513L15.1746 0.729734C15.6085 0.295818 16.312 0.295818 16.746 0.729734Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_6654_25960">
            <rect width="17.7778" height="10" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledContainer>
  );
};

export default Chevron;
